import styled from 'styled-components';


export const PersonalInfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;
  .ant-form-item {
    width: 100%;
    max-width: 596px;
  }
`;

export const EmergencyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;
  max-width: 800px;
`;
